import React from 'react';
import { Link } from 'react-router-dom';
import { CalculatorIcon, ShieldCheckIcon, ClockIcon } from '@heroicons/react/24/outline';
import RegisterForm from '../../components/auth/RegisterForm';

const Register = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Left side - Form */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-primary">
              Créez votre compte gratuit
            </h1>
            <p className="mt-3 text-gray-600">
              Rejoignez des milliers de propriétaires qui font confiance à SimulReno
            </p>
          </div>

          <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
            <RegisterForm />
            
            <div className="mt-6 text-center">
              <Link
                to="/login"
                className="text-sm text-primary hover:text-primary-dark"
              >
                Déjà un compte ? Se connecter
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Benefits */}
      <div className="hidden lg:flex lg:flex-1 bg-gradient-primary">
        <div className="flex-1 flex flex-col justify-center px-12 text-white">
          <h2 className="text-2xl font-bold mb-8">
            Les avantages de votre compte
          </h2>
          
          <div className="space-y-6">
            <BenefitItem
              icon={<CalculatorIcon />}
              title="Estimations illimitées"
              description="Réalisez autant d'estimations que vous le souhaitez et gardez-les en mémoire"
            />
            <BenefitItem
              icon={<ShieldCheckIcon />}
              title="Données sécurisées"
              description="Vos informations sont protégées et ne sont jamais partagées"
            />
            <BenefitItem
              icon={<ClockIcon />}
              title="Accès prioritaire"
              description="Soyez les premiers informés des nouvelles fonctionnalités"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const BenefitItem = ({ 
  icon, 
  title, 
  description 
}: { 
  icon: React.ReactNode; 
  title: string; 
  description: string;
}) => (
  <div className="flex items-start">
    <div className="flex-shrink-0 p-2 bg-white/10 rounded-lg">
      {icon}
    </div>
    <div className="ml-4">
      <h3 className="font-semibold">{title}</h3>
      <p className="mt-1 text-white/80 text-sm">{description}</p>
    </div>
  </div>
);

export default Register;